




















































































































import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { State } from 'vuex-class'

import { User } from '@/modules/User/interfaces/user'
import AppDialog from '@/components/AppDialog.vue'
import NewBusinessDialog from './components/NewBusinessDialog.vue'
import MenuCheckList from './components/MenuChecklist.vue'
import { dispatchSignOut } from '@/store/dispatches'
import { dateTimeToDisplay } from '@/utils/dateTime'
import { routerList } from '@/utils/routerList'
import { DrawerSubItem, DrawerItem } from '@/interfaces/drawer'
import AppGlobalSearch from '@/components/AppGlobalSearch.vue'
import UserPanel from './components/UserPanel.vue'
import SubMenuDrawer from './components/SubmenuDrawer.vue'
import EmailPanel from './components/EmailPanel.vue'

@Component({
  components: {
    AppDialog,
    NewBusinessDialog,
    MenuCheckList,
    AppGlobalSearch,
    UserPanel,
    SubMenuDrawer,
    EmailPanel
  }
})

export default class AppLayout extends Vue {
  @State(state => state.user.me) me!: User

  noMenu = ['SignIn']
  dialog = false
  isShowMessage = false
  showSearchBar = 0
  pActive = -1
  sActive = -1
  subMenuList: DrawerSubItem[] = []

  dateTimeToDisplay = dateTimeToDisplay

  version = process.env.VUE_APP_VERSION

  showMenuMore = false

  list: DrawerItem[] = routerList()
  customList: DrawerItem[] = []
  customListWidth = 0
  menuDomWidth = 0
  showMenuListArrows = false
  menuListOffsetX = 0
  offsetXIndex = 0
  offsetFix = 0
  lastOffset = 0
  subMenuItemDisplayCount = 0
  showSubMenuDrawer = false
  v1Href = ''

  menuMoreModal = {
    left: 0,
    top: 0,
    show: false,
    items: {}
  }

  panelModal = {
    left: 0,
    top: 0,
    show: false
  }

  emailPanelModal = {
    left: 0,
    top: 0,
    show: false
  }

  windowSize = {
    w: 0,
    h: 0
  }

  showNewBusinessDialog = false
  signOutDialog = false
  haveUnreadMsgs = 0

  get displaySubMenu () {
    const { subMenuItemDisplayCount, subMenuList } = this

    if (subMenuItemDisplayCount === subMenuList.length) {
      return subMenuList
    } else {
      const filter = subMenuList.slice(0, subMenuItemDisplayCount)
      return filter
    }
  }

  get hiddenSubMenu () {
    return this.subMenuList.slice(this.subMenuItemDisplayCount)
  }

  get maxTopnavOffset () {
    const { customList } = this

    return customList.reduce((prev, curr) => {
      return prev + curr.width + 12
    }, 0)
  }

  @Watch('$route')
  onRouteChanged (val: any) {
    const routeName = val.meta.menu || val.name
    this.setActive(routeName)
    const hrefArr = window.location.href.split('/#/')
    const domainName = 'https://wf.verge.group'
    const routes = hrefArr[1]
    this.v1Href = `${domainName}/v1/index.html#/${routes}`
  }

  @Watch('me')
  onMeChanged (val: User) {
    this.updateCustomList()
  }

  @Watch('windowSize.w')
  onWindowSizeChanged (newVal: number, oldVal: number) {
    const { menuListOffsetX, offsetXIndex, offsetFix, list } = this
    let offset = newVal - oldVal

    let newMenuListOffsetX = menuListOffsetX
    let newOffsetXIndex = offsetXIndex
    let newOffsetFix = offsetFix + offset

    if (!oldVal || !menuListOffsetX || offset <= 0) {
      return
    }

    for (let i = newOffsetXIndex - 1; i >= 0; i--) {
      const domWidth = list[i].width + 12
      if (newOffsetFix > domWidth) {
        newMenuListOffsetX += domWidth
        newOffsetFix -= domWidth
      } else {
        newOffsetXIndex = i + 1
        break
      }
    }

    this.offsetXIndex = newOffsetXIndex
    this.offsetFix = newOffsetFix
    this.menuListOffsetX = newMenuListOffsetX < 0 ? newMenuListOffsetX : 0
  }

  mounted () {
    const routeName = this.$route.meta && this.$route.meta.menu ? this.$route.meta.menu : this.$route.name

    this.setActive(routeName)
    this.updateCustomList()
  }

  ifMenu () {
    const routeName = this.$route.name
    return !this.$R.contains(routeName, this.noMenu)
  }

  onMenuMoreClick () {
    const menuMoreDiv = this.$refs.menuMore as Vue & {
      getBoundingClientRect: () => any;
    }

    this.menuMoreModal.left = menuMoreDiv.getBoundingClientRect().x - 100
    this.menuMoreModal.top = menuMoreDiv.getBoundingClientRect().y + 45
    this.menuMoreModal.show = true
  }

  onMenuChecklistChange () {
    const routeName = this.$route.meta && this.$route.meta.menu ? this.$route.meta.menu : this.$route.name
    this.updateCustomList()
    this.setActive(routeName)
  }

  onMenuCheckListClick (name: string) {
    const pItem = this.list.find(item => item.title === name)

    if (pItem) {
      this.pItemClickHandler(pItem)
    }
  }

  updateCustomList () {
    let itemsStr
    let width = 0
    if (this.me) {
      const key = 'VERGE_WF_CUSTOM_MENU_' + this.me.id

      itemsStr = localStorage.getItem(key)
    }

    const items = itemsStr
      ? JSON.parse(itemsStr)
      : this.list.reduce((prev: {
        [key: string]: boolean
      }, curr) => {
        prev[curr.title] = curr.display
        return prev
      }, {})

    this.customList = this.list.reduce((prev: DrawerItem[], curr) => {
      if (items[curr.title]) {
        prev.push(curr)
        width += curr.width + 12
      }

      return prev
    }, [])

    this.menuMoreModal.items = items
    this.customListWidth = width
    this.updateMenuDomWidth()
  }

  onResize () {
    this.windowSize = { w: window.innerWidth, h: window.innerHeight }

    this.updateMenuDomWidth()
    this.updateSubMenuDomHeight()
  }

  updateMenuDomWidth () {
    const { customListWidth, windowSize } = this
    // .c-layout__top-left
    const leftW = 160
    // .c-layout__top-right
    // const rightW = showSearchBar === 1 ? 277 : 120

    const viewWidth = windowSize.w - leftW - 277 - 140

    if (viewWidth > customListWidth) {
      this.showMenuListArrows = false
      this.menuDomWidth = customListWidth
    } else {
      this.showMenuListArrows = true
      this.menuDomWidth = viewWidth - 48
    }
  }

  updateSubMenuDomHeight () {
    const { subMenuList, windowSize } = this

    const topH = 50
    const viewHeight = windowSize.h - topH

    let count = 0
    let total = 0

    for (const item of subMenuList) {
      const { height } = item
      total = height ? total + height : total + 100
      if (total > viewHeight) {
        break
      }

      count += 1
    }
    this.subMenuItemDisplayCount = count === subMenuList.length
      ? count
      : count - 1
  }

  setActive (routeName: string) {
    let found = false
    for (const [i, p] of this.customList.entries()) {
      if (routeName === p.routeTo) {
        found = true
        this.pActive = i
        this.sActive = -1
      }

      if (p.subList && p.subList.length > 0) {
        for (const [j, s] of p.subList.entries()) {
          if (routeName === s.routeTo) {
            found = true
            this.pActive = i
            this.sActive = j
            this.subMenuList = p.subList
            this.updateSubMenuDomHeight()
            break
          }
        }
      }
    }

    if (!found) {
      this.pActive = -1
    }
  }

  routeTo (routeTo: string, params = {}) {
    if (routeTo === this.$route.name) {
      return
    }
    this.$router.push({
      name: routeTo,
      params
    })
  }

  onArrowClick (direct: number) {
    const { offsetXIndex, menuListOffsetX, customListWidth, menuDomWidth, list, maxTopnavOffset, lastOffset } = this

    const maxOffset = menuDomWidth - maxTopnavOffset

    if (direct === 1) {
      if (menuListOffsetX <= menuDomWidth - customListWidth) {
        return
      }
      if (menuListOffsetX - list[offsetXIndex].width - 12 < maxOffset) {
        this.lastOffset = maxOffset - menuListOffsetX
        this.menuListOffsetX = maxOffset
      } else {
        this.menuListOffsetX = menuListOffsetX - list[offsetXIndex].width - 12
      }
      this.offsetXIndex += 1
    } else {
      if (menuListOffsetX >= 0) {
        return
      }
      if (lastOffset) {
        this.menuListOffsetX = menuListOffsetX - lastOffset
        this.lastOffset = 0
      } else {
        this.menuListOffsetX = menuListOffsetX + list[offsetXIndex - 1].width + 12
      }
      this.offsetXIndex -= 1
    }
  }

  onSearchClick (show: boolean) {
    if (show) {
      this.showSearchBar = 1
    } else {
      this.showSearchBar = 2
    }
    this.updateMenuDomWidth()
  }

  onEmailClick () {
    const emailPanelDiv = this.$refs.emailPanel as Vue & {
      getBoundingClientRect: () => any;
    }
    this.emailPanelModal.left = emailPanelDiv.getBoundingClientRect().x - 130
    this.emailPanelModal.top = emailPanelDiv.getBoundingClientRect().y + 40
    this.emailPanelModal.show = true
  }

  onPanelClick () {
    const userPanelDiv = this.$refs.userPanel as Vue & {
      getBoundingClientRect: () => any;
    }

    this.panelModal.left = userPanelDiv.getBoundingClientRect().x - 130
    this.panelModal.top = userPanelDiv.getBoundingClientRect().y + 40
    this.panelModal.show = true
  }

  pItemClickHandler (pItem: DrawerItem) {
    if (pItem.routeTo) {
      this.routeTo(pItem.routeTo!, {})
    }

    if (pItem.subList) {
      const { subList } = pItem
      this.subMenuList = subList
      this.sItemClickHandler(subList[0])
    } else {
      this.subMenuList = []
    }
  }

  sItemClickHandler (sItem: DrawerSubItem) {
    if (sItem.routeTo) {
      this.routeTo(sItem.routeTo!, {})
    }
  }

  showNewBusinessDialogHandler () {
    this.showNewBusinessDialog = true
  }

  closeNewBusinessDialog () {
    this.showNewBusinessDialog = false
  }

  signOutHandler () {
    this.signOutDialog = false
    localStorage.removeItem(process.env.VUE_APP_JWT_NAME || 'VERGE_JWT_TOKEN')
    dispatchSignOut()
    this.$router.replace({ name: 'SignIn' })
  }

  showMessage () {
    this.routeTo('Message')
  }
}
